export function getAbbreviatedDay(day:string) {
    if(day == 'Sunday') return 'Sun.';
    if(day == 'Monday') return 'Mon.';
    if(day == 'Tuesday') return 'Tues.';
    if(day == 'Wednesday') return 'Wed.';
    if(day == 'Thursday') return 'Thurs.';
    if(day == 'Friday') return 'Fri.';
    if(day == 'Saturday') return 'Sat.';
    return day;
};

// https://stackoverflow.com/a/64489760
export function titleCase(s:string) {
  return s.replace (/^[-_]*(.)/, (_, c) => c.toUpperCase()) // Initial char (after -/_)
   .replace (/[-_]+(.)/g, (_, c) => ' ' + c.toUpperCase()) // First char after each -/_
}

export function columnNameToLabel(name:string) {
    name = name.replace('_id', '')
        .replace('_at', '');

    return titleCase(name);
}
